import './Avatar.scss';
import block from 'bem-cn';


const b = block('Avatar');

export type TAvatar = {
  image: string;
  isOnline?: boolean;
}

const Avatar = ({ image, isOnline = false }: TAvatar) => {

  return (
    <div className={b({ isOnline })}>
      <img className={b('image')} src={image} alt='avatar' />
    </div>
  )
}

export default Avatar;